module.exports = __webpack_public_path__ + "img/2-1.d9ad3855.jpg";